<template>
  <div class="add">
    <div>
      <header class="headet-title">
        <div class="headet-title-box">
          <p>修改登录密码</p>
        </div>
      </header>
      <div class="add-body">
        <el-form ref="editPasswordForm" label-width="210px" :model="editPasswordForm" style="padding-left:40px;" :rules="rules">
          <el-row>
            <el-form-item label="当前登录密码：">
              <span id="oldPwd" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="新登录密码：">
              <span id="newPwd" />
              <el-row class="hint">
                密码格式请设置成8-20位，数字、大小写字母、特殊字符（如！@等）的组合
              </el-row>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="确认登录密码：">
              <span id="newPwd2" />
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button class="sub" :loading="loadingSubmitBut" @click="changeSubmit">{{ loadingSubmitButtext }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <input id="lic" type="hidden">
  </div>
</template>
<script>
import { submitEditLoginPassword } from '@/api/security/security'
import jQuery from 'jquery'
import Session from '@/utils/session'
import pgeditorFn from '@/utils/pgeditor'
const pgeditor = pgeditorFn('_ocx_password', 1, '[\\s\\S]*', '[\\s\\S]{8,16}')
const pgeditor1 = pgeditorFn('_ocx_password1', 2, '[\\s\\S]*', '[\\s\\S]{8,16}')
const pgeditor2 = pgeditorFn('_ocx_password2', 3, '[\\s\\S]*', '[\\s\\S]{8,16}')
window.pgeCtrl = pgeditor

export default {
  name: 'EditLoginPassword',
  data() {
    return {
      editPasswordForm: {
        password: '',
        pass: '',
        checkPass: ''
      },
      loadingSubmitBut: false,
      loadingSubmitButtext: '提交'
    }
  },
  watch: {
    '$route': function(to, from) {
      this.$refs.editPasswordForm.resetFields()
      pgeditor.pwdClear()
      pgeditor1.pwdClear()
      pgeditor2.pwdClear()
    }
  },
  mounted() {
    jQuery('#oldPwd').html(pgeditor.load())
    jQuery('#lic').val(pgeditor.setLicense())
    pgeditor.pwdClear()
    jQuery('#newPwd').html(pgeditor1.load())
    jQuery('#lic').val(pgeditor1.setLicense())
    pgeditor1.pwdClear()
    jQuery('#newPwd2').html(pgeditor2.load())
    jQuery('#lic').val(pgeditor2.setLicense())
    pgeditor2.pwdClear()
  },
  methods: {
    changeSubmit() {
      this.$refs.editPasswordForm.validate(valid => {
        if (valid) {
          this.loadingSubmitBut = true
          this.loadingSubmitButtext = '提交中...'
          pgeditor.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
          pgeditor1.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
          pgeditor2.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
          const oldPwd = pgeditor.pwdResultSM()
          const newPwd = pgeditor1.pwdResultSM()
          const newPwds = pgeditor1.pwdHash()
          // const newPwd2 = pgeditor2.pwdResultSM()
          const newPwds2 = pgeditor2.pwdHash()
          if (pgeditor.pwdLength() === '0') {
            this.$message.error('请输入当前登录密码')
            return
          }
          // if (pgeditor.pwdValid() === '1') {
          //   this.$message({
          //     message: '原密码格式不正确，登录密码长度为8-20位',
          //     type: 'error'
          //   })
          //   this.loadingSubmitBut = false
          //   this.loadingSubmitButtext = '提交'
          //   return
          // }
          if (pgeditor1.pwdLength() === '0') {
            this.$message.error('请输入新登录密码')
            return
          }
          // if (pgeditor1.pwdValid() === '1') {
          //   this.$message({
          //     message: '新密码格式请设置成8-20位，数字、大小写字母、特殊字符（如！@等）的组合',
          //     type: 'error'
          //   })
          //   this.loadingSubmitBut = false
          //   this.loadingSubmitButtext = '提交'
          //   return
          // }
          // if (pgeditor1.pwdValid() === '1') {
          //   this.$message({
          //     message: '新密码格式不正确，登录密码长度为8-20位',
          //     type: 'error'
          //   })
          //   this.loadingSubmitBut = false
          //   this.loadingSubmitButtext = '提交'
          //   return
          // }
          if (oldPwd === newPwd) {
            this.$message({
              message: '新登录密码不能原登录密码相同',
              type: 'error'
            })
            pgeditor.pwdClear()
            pgeditor1.pwdClear()
            pgeditor2.pwdClear()
            this.loadingSubmitBut = false
            this.loadingSubmitButtext = '提交'
            return
          }
          if (newPwds2 !== newPwds) {
            this.$message({
              message: '两次新密码输入不不同',
              type: 'error'
            })
            pgeditor1.pwdClear()
            pgeditor2.pwdClear()
            this.loadingSubmitBut = false
            this.loadingSubmitButtext = '提交'
            return
          }

          const param = {
            id: Session.getItem('customerId'),
            password: oldPwd,
            newPassword: newPwd
          }
          submitEditLoginPassword(param).then((res) => {
            this.$alert('修改登录密码成功，请重新登录', '成功确认', {
              confirmButtonText: '确定',
              callback: action => {
                if (res.code === '0000' || res.code === '000000') {
                  this.loadingSubmitBut = false
                  this.loadingSubmitButtext = '提交'
                  this.$store.dispatch('user/resetToken').then(() => {
                    this.$router.push({ path: '/login' })
                  })
                } else {
                  this.loadingSubmitBut = false
                  this.loadingSubmitButtext = '提交'
                }
              }
            })
          }).catch(error => {
            console.log(error)
            this.loadingSubmitBut = false
            this.loadingSubmitButtext = '提交'
          })
        }
      })
    }
  }
}
</script>
<style>
#oldPwd,
#newPwd,
#newPwd2 {
  height: 40px;
}
#oldPwd input,
#newPwd input,
#newPwd2 input,
#_ocx_password,
#_ocx_password1,
#_ocx_password2 {
  border: 1px solid #dcdfe6;
  line-height: 40px;
  height: 40px;
  width: 90%;
  border-radius: 4px;
  padding: 0 15px;
}
</style>
<style scoped>
.add-body ::v-deep.el-form-item ::v-deep.ocx_style {
  border: 1px solid #dcdfe6;
  line-height: 40px;
  height: 40px;
  width: 200px;
  border-radius: 4px;
  padding: 0 15px;
}
.add-body ::v-deep.el-form-item ::v-deep.ocx_style:focus {
  outline: none;
  border: 1px solid #f56c6c;
}
.add {
  padding-bottom: 118px;
}
.headet-title {
  padding: 10px 30px 20px 30px;
}
.headet-title .headet-title-box {
  font-size: 16px;
  padding: 10px 0;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  border-bottom: 1px solid #dbdde2;
}
.headet-title-box {
  display: flex;
  align-items: center;
}
.headet-title-box > p:first-of-type {
  margin-right: 26px;
}

.add-body ::v-deep .el-input__inner {
  width: 236px;
  height: 32px;
  font-size: 13px;
  border-radius: 0px;
}
.sub {
  width: 118px;
  height: 40px;
  background: #e50007;
  color: #ffffff;
  border-radius: 0px;
  margin-top: 23px;
}
.hint {
  font-size: 12px;
  color: #a8a8a8;
}
</style>
